import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { requestSearchProduct } from 'requests/products'
import { qttInput } from 'utils/format'
import { SelectAutocomplete } from 'ui-components/SelectAutocomplete'
import AddIcon from '@material-ui/icons/Add'
import {
  InputForm,
} from 'components/Form/components'
import { Container, SelectContainer, AddButton } from './styles'

export default function AddItemForm({ onAddProduct }) {
  const [searching, setSearching] = useState(false)
  const [selectOptions, setSelectOptions] = useState([])
  const [selected, setSelected] = useState({})
  const [quantity, setQuantity] = useState(1)
  const [products, setProducts] = useState([])

  let searchTimer = null

  useEffect(() => {
    if (selectOptions.length === 1) {
      const [firstProduct] = selectOptions
      setSelected(firstProduct)
    }
  }, [selectOptions])

  const handleChangeQtt = (evt) => {
    const { value } = evt.target

    setQuantity(qttInput(value))
  }

  const handleProductSelect = (product) => {
    setSelected(product)
  }

  const handleAddProduct = async (evt) => {
    evt.preventDefault()
    if (!quantity || !selected.id) return

    setSelectOptions([])
    setSelected({})
    setProducts([])
    await onAddProduct({ quantity, product: selected })
    setQuantity(1)
  }

  const searchProduct = async (value) => {
    setSearching(true)
    const { data } = await requestSearchProduct(value)

    setSearching(false)
    if (!data?.length) return setProducts([])

    const options = data.map((product) => ({
      ...product,
      name: product.attributes.name,
    }))

    setProducts(data)
    return setSelectOptions(options)
  }

  const handleAutocomplete = (evt) => {
    const { value } = evt.target
    if (!value) {
      setSelectOptions([])
      return
    }

    if (value.length < 2) return

    clearTimeout(searchTimer)
    searchTimer = setTimeout(() => {
      searchProduct(value)
    }, 600)
  }

  return (
    <form onSubmit={handleAddProduct}>
      <Container>
        <InputForm
          label="Quantidade"
          name="quantity"
          value={quantity}
          onChange={handleChangeQtt}
        />

        <SelectContainer>
          <SelectAutocomplete
            label="Produto"
            name="product"
            options={selectOptions}
            onChange={handleAutocomplete}
            loading={searching}
            onSelect={handleProductSelect}
            noOptionsText={products.length ? 'Registro não encontrado' : 'Insira o código'}
            selected={selected}
          />
        </SelectContainer>

        <AddButton
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
        />
      </Container>
    </form>
  )
}

AddItemForm.propTypes = {
  onAddProduct: PropTypes.func.isRequired,
}
